import type { Color, PaletteColor } from '@mui/material'

export function toPaletteColor(color: Color): PaletteColor {
  return {
    light: color[300],
    main: color[500],
    dark: color[700],
    contrastText: '#fff',
  } as PaletteColor
}
